/**
 * Creation des minl entre les références et les barcode
 * attendu un fichier csv les 3 colonnes :
 *  - barcode
 *  - reference
 *  - label
 * doivent être identifiées
 */
import { ChangeDetectorRef, Component, HostListener, Input, NgZone, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { Subscription, Subject } from 'rxjs';
import { HttpResponse, HttpEventType } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { WksCentralService } from '../../../../services/wks-central.service';
import { TranslateService } from '../../../../../../services/translate.service';
import { ControlCsvService } from '../../../../../common/services/control-csv.service';
import { RessourcesService } from '../../../../../common/services/ressources.service';
import { ReadFile, ColumnsHeaderStatut, ColumnsHeaderUpload, FileUpload, Criterias, AlgoDatas, CalculationCmd, AlgoData } from '../../../../../../models/common.model';
import { ModalCommonComponent } from '../../../../../../job/common/components/modal-common/modal-common.component';

import { RemoteFilesService } from '../../../../../common/services/remote-files.service';
import { UserService } from '../../../../../../services/user.service';

import { CommonMethods } from '../../../../../../job/common/tools/commonMethods';

import { LangLabelModel, ParamCustoms } from '../../../../models/wks-param.model';
import { SUPPORTED_LANGS, LangSupportedModel } from '../../../../../../i18n/translation';

export interface ReportDataInput { 
  reportType: string;
  reportActive: boolean;
  reportTitle: string;
  reportSubTitle: string;
  contentMessage: string;
  progressBar: string;
  progressValue: number;
  progressMessage: string;
  statut: string;
  nbErrors: number;
  nbRows: number;
  fileOrig: number;
  fileTarget: number;
  rowContentError: {
    rowNum: number;
    whereClause: string;
    rowContent: any;
    errorType: string;
  }[];
}

@Component({
  selector: 'mdi-part-supplies-barcode',
  templateUrl: './part-supplies-barcode.component.html',
  styleUrls: ['./part-supplies-barcode.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class PartSuppliesBarcodeComponent implements OnInit, OnChanges  {

  @Input() statutCall: string;
  @Input() optionItem: string;
  @Input() actionType: string;
  @Input() randomIdString: string;

  progress: { percentage: number } = { percentage: 0 };
  private readonly onDestroy = new Subject<void>();
  @ViewChild('dropArea', {static: false}) dropArea: any;

  isFinishLoading: boolean;
  titleCard: string;

  alertMessage: boolean; 
  doUpload: boolean;
  doVerify: boolean;

  fileExt: String = 'TXT, CSV, XLSX';
  fileRead: ReadFile;
  messageInfo = '';
  dataMessageInfo1 = '';
  dataMessageInfo2 = '';
  messageType = '';
  supportedLangs: LangSupportedModel[];
  langLabelsList: LangLabelModel[];

  maxNbFiles: number;
  maxSizeDefault: number;
  maxSizePdf: number;
  maxSizeCSV: number; 

  numberFormat: {
    locale: string;
    minDecimal: string;
    maxDecimal: string;
    currency: string;
  };

  uploadFileNameCtrl: FormControl;
  uploadForm: FormGroup;
  isReadOnly: boolean;

  colErrors: string[];
  isUploadInProgress: boolean;
  reportDataInput: ReportDataInput[];
  dialogRef: MatDialogRef<ModalCommonComponent, any>;
  modalRef: BsModalRef;
  isReportActive: boolean;
  doAnalysisFile: boolean;
  colsName: string[];
  colPresent: {
    colName: string;
    colPresent: boolean;
  }[]; 
  isSearch: false;
  isAddOne: false;
  constructor(private fb: FormBuilder,
    private _wksCentralService: WksCentralService,
    private _userService: UserService,
    private _controlCsvService: ControlCsvService,
    private _remoteFilesService: RemoteFilesService,
    private _translate: TranslateService,
    private ressourceService: RessourcesService,
    private zone: NgZone ,
    private _dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private _modalService: BsModalService,
    ) { }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
 
    const listKey = Object.keys(changes);
    for (const propName of listKey) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'actionType': {
            this.actionType = changes['actionType'].currentValue;
            break;
          }
          case 'statutCall': {
            this.statutCall = changes['statutCall'].currentValue;
            break;
          }
          case 'optionItem': {
            this.optionItem = changes['optionItem'].currentValue;
            break;
          }
          case 'randomIdString': {
            this.randomIdString = changes['randomIdString'].currentValue;
            break;
          }
        } // end switch
      } // end if
    } // end loop
    
    this.initData();
    this.isFinishLoading = true;
  }
  initData() {
    this.initAllBooleans();
    this.titleCard = 'updateLinkBarcodeRef';
    this.initOthers();
    this.settingFormats();
    this.buildForm(); 
  }
  initAllBooleans(): void {
    this.isFinishLoading = false;
    this.alertMessage = false;
    this.doUpload = false;
    this.doVerify = false;
    this.isFinishLoading = false;
    this.alertMessage = false;
    this.doUpload = false;
    this.doVerify = false;
    this.isUploadInProgress = false;
    this.isReadOnly = false;
   
    this.initReportInput();
  } 
  initReportInput(): void {
    this.reportDataInput = [];
    for (let i = 0 ; i < 15 ; i++) {
      this.reportDataInput[i] = this.emptyDataInput();
    }
    
  }
  emptyDataInput(): ReportDataInput {
    const reportDataInputEmpty = {
      reportType: '',
      reportActive: false,
      reportTitle: '',
      reportSubTitle: '',
      contentMessage: '',
      progressBar: '',
      progressValue: 0,
      progressMessage: '',
      statut: '',
      nbErrors: 0,
      nbRows: 0,
      fileOrig: -1,
      fileTarget: -1,
      rowContentError: []
    };
    return reportDataInputEmpty;
  }
  doCancel() {
    if  (this.statutCall === 'sidenav') {
      this._wksCentralService.onRegisterValid.emit('cancelUpdateLinkBarcodeRef');
      return;
    }
  }
  initOthers(): void {

    this.settingFormats();

    this.langLabelsList = [];
    this.supportedLangs = [...SUPPORTED_LANGS];
    for (const langCur of this.supportedLangs) {
      const langTmp: LangLabelModel = {
        langValue: langCur.value,
        langDisplay: this._translate.getTranslate(langCur.display),
        langDirection: langCur.direction,
        langLabel: ''
      } ;
      this.langLabelsList.push(langTmp);
    }
    this.maxNbFiles = (this._wksCentralService.getWksMaxDefaults().maxNbFiles ? this._wksCentralService.getWksMaxDefaults().maxNbFiles : 5);
    this.maxSizeDefault = (this._wksCentralService.getWksMaxDefaults().maxSizeDefault ? this._wksCentralService.getWksMaxDefaults().maxSizeDefault : 20);
    this.maxSizePdf = (this._wksCentralService.getWksMaxDefaults().maxSizePdf ? this._wksCentralService.getWksMaxDefaults().maxSizePdf : 20);
    this.maxSizeCSV = (this._wksCentralService.getWksMaxDefaults().maxSizeCSV ? this._wksCentralService.getWksMaxDefaults().maxSizeCSV : 20);

    this.colsName = ['label', 'barcode', 'reference'];
    this.colPresent = [];
    let idxCol = 0;
    for (const item of this.colsName) {
      const itemTmp = {
        colName: item,
        colPresent: false
      };
      this.colPresent.push(itemTmp);
      idxCol++;
    }
  }
  settingFormats(): void {
    const otherData = JSON.parse(this._wksCentralService.getWksEntityCur().otherData);
    const intFormat = otherData.internationnalFormat;

    this.numberFormat = {
      locale: this.ressourceService.getFormat(intFormat, 'numbers', 'locale'),
      minDecimal: this.ressourceService.getFormat(intFormat, 'numbers', 'minimumFractionDigits'),
      maxDecimal: this.ressourceService.getFormat(intFormat, 'numbers', 'maximumFractionDigits'),
      currency:  this.ressourceService.getFormat(intFormat, 'numbers', 'currency'),
    };

  }
  buildForm() {

    this.uploadFileNameCtrl = this.fb.control({value: '', disabled: this.isReadOnly});
    this.uploadForm = this.fb.group({
      uploadFileName: this.uploadFileNameCtrl,
    },
    {
      updateOn: 'blur'
    });
  }
  modifFiles() {
    this.doAnalysisFile = false; 
    this.isReportActive = false; 
    this.initReportInput();
  }
  // ============================================================== start files
  onFileChange(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.alertMessage = false;
    this.doUpload = false;
    this.doVerify = false;

    if (event.target.files && event.target.files.length > 0) {
      const files = event.target.files;
      if ((files.length > 0) && (this.isValidFiles(files))) {
        const file: File = files[0];
        const readingFile: ReadFile = new ReadFile();
        readingFile.nameFile = file.name;
        readingFile.sizeFile = file.size;
        readingFile.typeFile = file.type;
        readingFile.fileObject = file;
        readingFile.messageFile = '';
        readingFile.uploadedFile = false;
        readingFile.validatedFile = false;
        this.doUpload = false;
        this.doVerify = true;
        this.fileRead = readingFile;
        this.uploadForm.controls.uploadFileName.setValue(readingFile.nameFile);
      } else  {
        this.doUpload = false;
        this.doVerify = false;
        this.uploadForm.controls.uploadFileName.setValue('');
        this.fileRead = undefined;
      }
    } 
    const input = event.target as HTMLInputElement;
    input.value = '';
  }
  private isValidFiles(files): boolean {

    // Check Number of files
    if (files.length > this.maxNbFiles) {
      this.alertMessage = true;
      this.messageType = 'ERROR';
      this.messageInfo = 'The maximum number of files is reached';
      this.dataMessageInfo1 = files.length.toString() ;
      this.dataMessageInfo2 = this.maxNbFiles.toString() ;
      this.messageBoxDisplay('lenghtfile');
      return false;
    } else {
      return this.isValidFileExtension(files);
    }

  }
  private isValidFileExtension(files: any): boolean {
    // Make array of file extensions
    const extensions = (this.fileExt.split(','))
                    .map(function (x) { return x.toLocaleUpperCase().trim(); } );
    this.alertMessage = false;
    for (let i = 0; i < files.length; i++) {
        // Get file extension
        const ext = files[i].name.toUpperCase().split('.').pop() || files[i].name;
        // Check the extension exists
        const exists = extensions.includes(ext);
        if (!exists) {
            this.alertMessage = true;
            this.messageType = 'ERROR';
            this.messageInfo = 'unrecognized extension';
            this.dataMessageInfo1 = ext ;
            this.dataMessageInfo2 = files[i].name ;
            this.messageBoxDisplay('extensionfile');
            break;
        }
        if (!this.alertMessage) {
        // Check file size
          this.isValidFileSize(files[i], ext);
          break;
        } else {
          continue;
        }
    }
    if (this.alertMessage) {
      return false;
    } else {
      return true;
    }
  }

  private isValidFileSize(_file: any, ext: string): boolean {
    const fileSizeinMB = _file.size / (1024 * 1000);
    const size = Math.round(fileSizeinMB * 100) / 100; // convert upto 2 decimal place
    let sizeIsValid = true;
    switch (ext) {
      case 'PDF':
        if (size > this.maxSizePdf) {
            this.alertMessage = true;
            this.messageType = 'ERROR';
            this.messageInfo = 'too heavy file size';
            this.dataMessageInfo1 = _file.name  ;
            this.dataMessageInfo2 = size.toString() + ' MB / ' + this.maxSizePdf.toString() + 'MB MAX' ;
            this.messageBoxDisplay('lenghtfile');
            sizeIsValid = false;
        }
        break;
        case 'CSV':
          if (size > this.maxSizeCSV) {
            this.alertMessage = true;
            this.messageType = 'ERROR';
            this.messageInfo = 'too heavy file size';
            this.dataMessageInfo1 = _file.name  ;
            this.dataMessageInfo2 = size.toString() + ' MB / ' + this.maxSizeCSV.toString() + 'MB MAX' ;
            this.messageBoxDisplay('lenghtfile');
            sizeIsValid = false;
          }
          break;
          default: 
          if (size > this.maxSizeDefault) {
            this.alertMessage = true;
            this.messageType = 'ERROR';
            this.messageInfo = 'too heavy file size';
            this.dataMessageInfo1 = _file.name  ;
            this.dataMessageInfo2 = size.toString() + ' MB / ' + this.maxSizeDefault.toString() + 'MB MAX' ;
            this.messageBoxDisplay('lenghtfile');
            sizeIsValid = false;
          }
    }
    return sizeIsValid;
  }
  // drag and drop 
  @HostListener('dragover', ['$event']) public onDragOver(evt: Event) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dropArea.nativeElement.style.background = 'red';
    this.dropArea.nativeElement.style.border = 'dashed 3px red';
    this.alertMessage = false;
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: Event) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dropArea.nativeElement.style.background = 'var(--background-primary)!important';
    this.dropArea.nativeElement.style.border = 'dotted 3px grey'; 
  }

  @HostListener('drop', ['$event']) public onDrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dropArea.nativeElement.style.background = 'var(--background-primary)!important';
    this.dropArea.nativeElement.style.border = 'dotted 3px grey';
    const files = evt.dataTransfer.files;

    if ((files.length > 0) && (this.isValidFiles(files))) {
      const file: File = files[0];
      const readingFile: ReadFile = new ReadFile();
      readingFile.nameFile = file.name;
      readingFile.sizeFile = file.size;
      readingFile.typeFile = file.type;
      readingFile.fileObject = file;
      readingFile.messageFile = '';
      readingFile.uploadedFile = false;
      readingFile.validatedFile = false;
      this.doUpload = false;
      this.doVerify = true;
      this.fileRead = readingFile;
      this.uploadForm.controls.uploadFileName.setValue(readingFile.nameFile);
    } else  {
      this.doUpload = false;
      this.doVerify = false;
      this.uploadForm.controls.uploadFileName.setValue('');
      this.fileRead = undefined;
    }
  }
// ============================================================== end files

  uploadFile() {
    this.closeMatDialog();
    this.messageInfo = 'upate barcode in progress';
    this.dataMessageInfo1 = this.fileRead.nameFile ;
    this.messageBoxDisplay('UpdateBarcodeProgress');
    this.uploadProcess(this.fileRead.fileObject).then(
      (val: any) => {
        this.closeMatDialog();
        this.messageInfo = 'update barcode file OK';
        this.dataMessageInfo1 = this.fileRead.nameFile ;
        
        this.doVerify = false;
        this.doUpload = false;
        this.uploadForm.controls.uploadFileName.setValue('');
        this.messageBoxDisplay('uploadOK');
      },
      (error) => {
        this.closeMatDialog();
        console.log('UPLOAD KO ' + this.fileRead.fileObject.name + ' : ' + error);
        this.messageInfo = 'upload file KO';
        this.dataMessageInfo1 = this.fileRead.nameFile ;
        this.dataMessageInfo2 = '(' + error + ')'  ;
        this.doVerify = false;
        this.doUpload = false;
        this.uploadForm.controls.uploadFileName.setValue('');
        this.messageBoxDisplay('uploadKO');
      }
    ); // end then uploadFile

  }
  private endProcessFile() {
    this.closeMatDialog();
    if  (this.statutCall === 'sidenav') {
      this._wksCentralService.onRegisterValid.emit('closeUpload');
      return;
    }
  }
  
  verifyFile(): void {
   
    this.readFile(this.fileRead.fileObject)
    .then((result) => {
      const arrayOfLines = result as any[];
      const colsCur = arrayOfLines[0].split(';');
      for (const colCur of colsCur) {
        this.colPresent.find(c => {
          if (c.colName.toLowerCase() === colCur.toLowerCase()) {
            c.colPresent = true;
          }
        });
      }
      let notExists = false;
      for (const itemPresent of this.colPresent) {
        if (!itemPresent.colPresent) {
          notExists = true;
          break;
        }
      }
      if (notExists) {
        this.doVerify = true;
        this.doUpload = false;
        this.closeMatDialog();
        console.log('Verify file KO ' );
        this.messageInfo = 'verifyFileKOMessage';
        this.dataMessageInfo1 = this.fileRead.nameFile ;
        this.messageBoxDisplay('verifyFileKO');
      } else {
        this.doVerify = false;
        this.doUpload = true;
      } 
    }) 
    .catch((error) => {
      console.error(error);
      this.closeMatDialog();
      console.log('Verify file KO ' );
      this.messageInfo = 'verifyFileKO';
      this.dataMessageInfo1 = this.fileRead.nameFile ;
      this.dataMessageInfo1 = 'Error : ' + JSON.stringify(error);
      this.messageBoxDisplay('verifyFileKO');
      return false;
    }); 
    return ;
  }
  private readFile(_file: File) {

    return  new Promise((resolve, reject) => {
      this._controlCsvService.readCsvFile(_file).then(
        (arrayOfLines) => {
          resolve(arrayOfLines);
        },
        (error) => {
          console.error('File could not be read! Code ' + error);
          reject('ProcessControlKO');
        },
      ); 
    });
  }
  // upload
  private uploadProcess(_file: File) {
    return  new Promise<void>((resolve, reject) => {
      this.isUploadInProgress = true;
      this._remoteFilesService.pushFilePartsSuppliesBarcode(_file, 'partsSuppliesBarcode', this._userService.getUserLogged().entity).subscribe((event) => {
          console.log('event : ' + event);
          console.log('File is completely uploaded!');
          this.isUploadInProgress = false;
          resolve();
        },
        response => {
          const numError = response.status;
          let message: String;
          switch (numError) {
            case 417:
              message = this._translate.getTranslate('Duplicate file');
              console.log('Error  Message ' + response.message +
                    + 'Status ' + response.status + ' user message : ' + message);
              break;
            case 418:
              message = this._translate.getTranslate('Error file');
              console.log('Error  Message ' + response.message +
                    + 'Status ' + response.status + ' user message : ' + message);
              break;
              case 200:
                break;
              case 202:
                break;
            default:
              message = this._translate.getTranslate('Upload error file');
              console.log('Error  Message ' + response.message +
                      + 'Status ' + response.status + ' user message : ' + message);
              break;
            }
            if (numError === 200 || numError === 202 ) {
              const messageText = response.error.text;
              resolve(messageText);
            }
            this.isUploadInProgress = false;
            reject(message);
          } ,
        );
      });
  }
  // errors files
  saveFileCsv(csvArray: any[], fileName: string): void {
    CommonMethods.saveFileCsv(csvArray, fileName);
  }

  // ========================================================== errors alerts 
  messageBoxDisplay(_actionCur: string) {
    const dialogConfig = new MatDialogConfig();
    let titleBox: string;
    let action: string;
    let typeBox = 'alertWks';
    let progressDeterminate: boolean;
    const argsMessage = [this.dataMessageInfo1, this.dataMessageInfo2];
    const messageBox = this._translate.instant(this.messageInfo, argsMessage );

    this.modifFiles();
    this.isReportActive = false;

    if (_actionCur === 'lenghtfile') {
      titleBox = 'too heavy file'; 
      this.colErrors = undefined;
    }
    if (_actionCur === 'extensionfile') {
      titleBox = 'extension error';
      this.colErrors = undefined;
    }
    if (_actionCur === 'csvControl') {
      titleBox = 'ReportAnalyzeCSV';
      action = 'csvControl';
    }
    // verifyFileKO
    if (_actionCur === 'verifyFileKO') {
      titleBox = 'Verify File';
      this.colErrors = undefined;
    }
    // UpdateBarcodeProgress
    if (_actionCur === 'UpdateBarcodeProgress') {
     typeBox = 'infoProgressWks';
     titleBox = 'UpdateBarcodeTitle';
    }
    if (_actionCur === 'uploadOK') {
      titleBox = 'upload File parts & supplies';
      this.colErrors = undefined;
    }
    if (_actionCur === 'uploadKO') {
      titleBox = 'upload File parts & supplies';
      this.colErrors = undefined;
    }
    if (_actionCur === 'analysisFile') {
      titleBox = 'analysisFileTitle';
      this.colErrors = undefined;
      typeBox = 'infoProgressWks';
    }
    if (_actionCur === 'multiFilesAnalyze') {
      titleBox = 'multiFilesAnalyzeTitle';
      this.colErrors = undefined;
      typeBox = 'infoProgressWks';
    }

    if (_actionCur === 'verifCrossReferences') {
      titleBox = 'verifCrossReferencesTitle';
      typeBox = 'infoProgressWks',
      progressDeterminate = false;
      this.colErrors = undefined;
    }
    // uploadMultiProcess
    if (_actionCur === 'uploadMultiProcess') {
      titleBox = 'uploadMultiProcessTitle';
      typeBox = 'infoProgressWks';
      this.colErrors = undefined;
    }
    // uploadMultiFilesOK
    if (_actionCur === 'uploadMultiFilesOK') {
      titleBox = 'uploadMultiFilesOKTitle';
      this.colErrors = undefined;
    }
    if (_actionCur === 'extractData') {
      titleBox = 'extractData';
      typeBox = 'infoProgressWks';
      progressDeterminate = true;
      this.colErrors = undefined;
    }
    if (_actionCur === 'analysisData') {
      titleBox = 'analysisData';
      typeBox = 'infoProgressWks';
      progressDeterminate = true;
      this.colErrors = undefined;
    }
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      id: 1,
      title: this._translate.getTranslate(titleBox),
      typeDialog: typeBox,
      panelClass: 'stdTheme',
      contentMessage: messageBox,
      data1: '',
      data2: '',
      actionCur: action,
      progressDeterminate: progressDeterminate,
      errorsList: this.colErrors,
      messageType: 'ERROR'
    };
  //   this._dialog.open(ModalCommonComponent, dialogConfig);
    this.zone.run(() => this.dialogRef = this._dialog.open(ModalCommonComponent, dialogConfig));
    // this.dialogRef = this._dialog.open(ModalCommonComponent, dialogConfig);
    
    this.dialogRef.afterClosed()
    .pipe(takeUntil(this.onDestroy))
    .subscribe(
      data => {
        if (_actionCur === 'uploadOK') {
          this.endProcessFile();
        } else if (_actionCur === 'uploadMultiFilesOK') {
          this.endProcessFile();
        } else if (_actionCur === 'UpdateBarcodeProgress') {
          // this.endProcessFile();
        } else {
          this.closeMatDialog();
        }
      });

  }
  closeMatDialog(): void {
    this._dialog.closeAll();

    // console.log(this._dialog.openDialogs.length);
    if (this._dialog.openDialogs.length > 0) {
  
      for (const instCur of this._dialog.openDialogs) {
        this._dialog.openDialogs.splice(0, 1);
      }
    }
    this.dialogRef = null;
  }
  
}
